export default __webpack_public_path__ + "static/media/N4.84d1af54.png";